const values = {
  text: "var(--easyy-font-family)",
  mono: "var(--easyy-font-family-monospace)",
  heading: "var(--easyy-font-family-headings)",
}

export function fontFamilyResolver(fontFamily: unknown) {
  if (typeof fontFamily === "string" && fontFamily in values) {
    return values[fontFamily as keyof typeof values]
  }

  return fontFamily
}
